export default __webpack_public_path__ + "c5bc33e209f8718ea3f71fa1725cedec.png";